import React from "react";

function Arctrax() {
	return (
		<div className="container">
			<div className="container--inner">
				<h1>ArcTrax Reach+</h1>
			</div>
		</div>
	);
}

export default Arctrax;
